/**********************************************************
Fertilizer
**********************************************************/
import Tabs from '../tabs';
import { FERTILIZER_URLS } from '../../cult_constants';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class FertilizerContainer extends Component {
  render() {
    return (
      <div>
        <div>
          <Tabs tabs={FERTILIZER_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(FertilizerContainer);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/fertilizer/fertilizer_container.js